<script setup lang="ts">
/**
 * Puts the org's brand on the document. Mounted once, at the top (App.vue):
 * a screen that set the colours itself would remove them when left.
 * Renders nothing.
 */
import { onBeforeUnmount, watch } from 'vue'
import { applyTokens } from './tokens'
import { useSavedTokens } from './savedTokens'

const { tokens } = useSavedTokens()
watch(tokens, (t) => applyTokens(t), { immediate: true })
/* Unmounted (logged out, another org): the next session starts from the stock tokens. */
onBeforeUnmount(() => applyTokens({}))
</script>

<template></template>
